import Home from '@/views/Home'
import Percurso from '@/views/Percurso'
import Regulamento from '@/views/Regulamento'
// import Resultado from '@/views/Resultado'
import NewResultado from '@/views/NewResultado'
import PerguntasFrequentes from '@/views/PerguntasFrequentes'
import InscrevaSe from '@/views/InscrevaSe'
// import Homologacao from '@/views/Homologacao'

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      showNav: false,
      hash: '#informacoes-gerais',
      label: 'Informações'
    }
  },
  {
    path: '/percurso-e-dicas',
    name: 'percurso',
    component: Percurso,
    meta: {
      showNav: true,
      label: 'Percurso e Dicas'
    }
  },
  {
    path: '/regulamento',
    name: 'regulamento',
    component: Regulamento,
    meta: {
      showNav: true,
      label: 'Regulamento'
    }
  },
  // {
  //   path: '/resultado',
  //   name: 'resultado',
  //   component: Resultado,
  //   meta: {
  //     showNav: true,
  //     label: 'Resultado'
  //   }
  // },
  {
    path: '/resultado',
    name: 'resultado',
    component: NewResultado,
    meta: {
      showNav: true,
      label: 'Resultado'
    }
  },
  {
    path: '/duvidas',
    name: 'perguntasFrequentes',
    component: PerguntasFrequentes,
    meta: {
      showNav: true,
      label: 'Dúvidas'
    }
  },
  {
    path: '/inscreva-se',
    name: 'inscrevase',
    component: InscrevaSe,
    meta: {
      label: 'Inscreva-se'
    }
  },
  // {
  //   path: '/homologacao',
  //   name: 'homologacao',
  //   component: Homologacao,
  //   meta: {
  //     label: 'Homologação'
  //   }
  // },
]
